import styled from 'styled-components';

export const Button = styled.button`
  font-family: Avenir;
  -webkit-appearance: none;
  background: linear-gradient( rgba(24,112,57,0.86), rgba(162,210,81,0.83));
  color: #ffffff;
  text-align: center;
  padding: 10px 14px;
  font-size: 16px;
  font-weight: bold;
  width: auto;
  border-radius: 5px;
  border: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  cursor: pointer;
  display: inline-block;
  float: right;
  margin-top: 20px;
`

export const StartButton = styled.button`
  display: block;
  float: left;
  font-family: Avenir;
  -webkit-appearance: none;
  background: linear-gradient( rgba(24,112,57,0.86), rgba(162,210,81,0.83));
  color: #ffffff;
  text-align: center;
  padding: 10px 14px;
  font-size: 16px;
  font-weight: bold;
  width: auto;
  border-radius: 5px;
  border: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  cursor: pointer;
`

export const StepText = styled.p`
  font-family: 'Rubik', sans-serif;
  padding-left: 20px;
  font-size: 1.4em;
  color: #00000;
  padding-bottom: 0px;
`

export const ContentBlock = styled.div`
  padding: 0;
  margin: 0;
  font-size: 1em;
`

export const InstructionTxt = styled(StepText)`
  font-size: 1.3em;
  color: #4b4c4c;
  margin-left: 4px;
  font-weight: 400;
  font-family: 'Rubik', sans-serif;
`


export const BackButton = styled(Button)`
  margin-right: 20px;
  background: #ffffff;
  color: gray;
  ${props => !props.backActive &&`
    display: none;
  `}
`

export const NextButton = styled(Button)`
  margin-right: 20px;
  ${props => !props.nextActive &&`
    display: none;
  `}
`

export const InputSubmitButton = styled(Button)`
  margin-right: 20px;
  ${props => !props.inputActive &&`
    display: none;
  `}
`


// export const DataSelectBtn = styled(Button)`
//   /* background: linear-gradient(to right, #020d39, #012e58, #134e75, #307190, #5394a9); */
//   margin-right: 12px;
//   float: left;
//   ${props => !props.inputSwapActive &&`
//     display: none;
//   `}
// `

export const InputTableWrapper = styled.div`

`



export const InputStepContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  grid-row-gap: 12px;
  margin-left: 24px;
`

export const TableWrapper = styled.div`
  margin-left: 20px;
`

export const LoadingCover = styled.div`
  position: fixed;
  padding-top: 100px;
  width: 100%;
  height: 100%;
  padding: 15% 35%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 1;
`

export const LoadingInner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -50px;
`
